<template>
  <div class="content-body">
    <div class="top">广告计划</div>
    <div class="body">
      <el-button type="primary" icon="el-icon-plus" size="small" @click="addPlan">新建广告计划</el-button>
      <div class="condition">
        <div class="form">
          <div class="demo-input-suffix">
            广告主:
            <el-select v-model="form.type" placeholder="请选择活动区域" size="small" style="width: 160px; margin-left: 10px;">
              <el-option label="不限" value=""></el-option>
              <el-option :label="company_name" value="1"></el-option>
            </el-select>
          </div>
          <div class="demo-input-suffix">
            广告组:
            <el-input v-model="form.plan_keyword" placeholder="" style="width: 160px; margin-left: 10px;" size="small"></el-input>
          </div>
          <div class="demo-input-suffix">
            物料名称:
            <el-input v-model="form.material_keyword" placeholder="" style="width: 160px; margin-left: 10px;" size="small"></el-input>
          </div>
          <div class="demo-input-suffix">
            推广计划:
            <el-input v-model="form.keyword" placeholder="" style="width: 160px; margin-left: 10px;" size="small"></el-input>
          </div>
          <div class="demo-input-suffix">
            广告状态:
            <el-select v-model="form.status" placeholder="请选择活动区域" size="small" style="width: 160px; margin-left: 10px;">
              <el-option label="不限" value=""></el-option>
              <el-option label="开启" value="1"></el-option>
              <el-option label="关闭" value="0"></el-option>
            </el-select>
          </div>
          <!-- <div class="demo-input-suffix">
            投放平台:
            <el-select v-model="form.system" placeholder="请选择活动区域" size="small" style="width: 160px; margin-left: 10px;">
              <el-option label="不限" value=""></el-option>
              <el-option label="Android" value="1"></el-option>
              <el-option label="IOS" value="2"></el-option>
              <el-option label="other" value="3"></el-option>
            </el-select>
          </div> -->
          <div class="demo-input-suffix">
            投放时间:
            <el-date-picker v-model="form.pay_time" type="daterange" value-format="yyyy-MM-dd" style="width: 250px;" align="right" size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
          <div style="margin: 20px 0;">
            <!-- <div class="demo-input-suffix">
              投放样式:
              <el-select v-model="form.upload_type" placeholder="请选择活动区域" size="small" style="width: 160px; margin-left: 10px;">
                <el-option label="不限" value=""></el-option>
                <el-option :label="item" :value="index" v-for="(item, index) in uploadData" v-if="index > 0" :key="index"></el-option>
              </el-select>
            </div> -->
            <!-- <div class="demo-input-suffix">
              投放位置:
              <el-select v-model="form.position" placeholder="请选择活动区域" size="small" style="width: 160px; margin-left: 10px;">
                <el-option label="不限" value=""></el-option>
              </el-select>
            </div> -->
            <div class="demo-input-suffix">
              收费方式:
              <el-select v-model="form.pay_type" placeholder="请选择活动区域" size="small" style="width: 160px; margin-left: 10px;">
                <el-option label="不限" value=""></el-option>
                <el-option label="CPM" value="1"></el-option>
                <el-option label="CPC" value="2"></el-option>
                <el-option label="oCPA" value="3"></el-option>
              </el-select>
            </div>
            <el-button type="primary" @click="search" size="small">查询</el-button>
            <div class="demo-input-suffix" style="margin-left: 150px;">
              是否查询数据量值:
              <el-switch v-model="form.isData" style="margin-left: 10px;" @change="getData()"></el-switch>
            </div>
          </div>
        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" border show-summary style="width: 1870px" :show-overflow-tooltip="true" @cell-mouse-enter="rowChange" @cell-mouse-leave="leaveRow" size="small" sum-text="汇总" :header-cell-style="{ 'background-color': '#F4F4F4', 'font-weight': 'bold', 'color': '#333' }">
          <el-table-column prop="id" label="开关" width="80" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" @change="changeStatusOne(scope.$index)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column width="200" label="广告计划" align="center">
            <template slot-scope="scope">
              <a href="javascript:;" @click="showDrawer(scope.row)">{{ scope.row.adv_name }}</a>
              <i style="color: #0782C3; font-size: 14px; cursor: pointer; margin-left: 3px;" @click="editOne3(scope.$index)" class="el-icon-edit-outline" v-if="scope.row['isShowEditIcon'] !== undefined && scope.row['isShowEditIcon']"></i>
            </template>
          </el-table-column>
          <el-table-column width="200" label="物料名称" align="center">
            <template slot-scope="scope">
              {{ scope.row.material_name }}
            </template>
          </el-table-column>
          <el-table-column width="200" label="广告计划ID" align="center">
            <template slot-scope="scope">
              {{ scope.row.adv_id }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="160">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="editOne(scope.row)">编辑</el-button>
              <el-button type="text" size="mini" @click="copyOne(scope.row.adv_id)">复制</el-button>
              <el-button type="text" style="color: red;" size="mini" @click="delOne(scope.row.adv_id)">删除</el-button>
            </template>
          </el-table-column>
          <el-table-column width="100" label="状态" align="center">
            <template slot-scope="scope">
              {{ scope.row.status ? '已投放' : '待投放' }}
            </template>
          </el-table-column>
          <el-table-column width="100" label="审核备注" align="center">
            <template slot-scope="scope">
              {{ handleData[scope.row.handle] }}
            </template>
          </el-table-column>
          <el-table-column width="200" label="广告组" align="center">
            <template slot-scope="scope">
              {{ scope.row.title }}
              <i style="color: #0782C3; font-size: 14px; cursor: pointer; margin-left: 3px;" @click="editOne2(scope.$index)" class="el-icon-edit-outline" v-if="scope.row['isShowEditIcon'] !== undefined && scope.row['isShowEditIcon']"></i>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="广告主" width="250" align="center">
            <template>
              {{ company_name }}
            </template>
          </el-table-column>
          <!-- <el-table-column width="100" label="投放平台" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.phone_system.includes('1')">Android,</span>
              <span v-if="scope.row.phone_system.includes('2')">IOS</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column width="100" label="广告样式" align="center">
            <template slot-scope="scope">
              {{ uploadData[scope.row.upload_type] }}
            </template>
          </el-table-column>
          <el-table-column width="100" label="投放系统" align="center">
            <template>
              移动版
            </template>
          </el-table-column> -->
          <el-table-column width="90" label="投放开始时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.pay_time }}
            </template>
          </el-table-column>
          <el-table-column width="100" label="投放结束时间" align="center">
            <template>
              永久
            </template>
          </el-table-column>
          <el-table-column width="100" label="预算类型" align="center">
            <template slot-scope="scope">
              {{ scope.row.adv_type === 1 ? '日预算' : '总预算' }}
            </template>
          </el-table-column>
          <el-table-column width="100" label="广告预算" align="center">
            <template slot-scope="scope">
              {{ scope.row.adv_budget }}
              <i style="color: #0782C3; font-size: 14px; cursor: pointer; margin-left: 3px;" @click="editOne4(scope.$index)" class="el-icon-edit-outline" v-if="scope.row['isShowEditIcon'] !== undefined && scope.row['isShowEditIcon']"></i>
            </template>
          </el-table-column>
          <el-table-column width="100" label="出价" align="center">
            <template slot-scope="scope">
              {{ scope.row.price }}
              <i style="color: #0782C3; font-size: 14px; cursor: pointer; margin-left: 3px;" @click="editOne5(scope.$index)" class="el-icon-edit-outline" v-if="scope.row['isShowEditIcon'] !== undefined && scope.row['isShowEditIcon']"></i>
            </template>
          </el-table-column>
          <el-table-column width="100" label="收费方式" align="center">
            <template slot-scope="scope">
              {{ parseInt(scope.row.pay_type) === 1 ? 'CPM' : 'CPC' }}
            </template>
          </el-table-column>
          <!-- <el-table-column width="100" label="投放位置" align="center">
            <template slot-scope="scope">
              {{ parseInt(scope.row.position) === 1 ? '信息流' : '详情页' }}
            </template>
          </el-table-column> -->
          <el-table-column prop="read" label="曝光量" width="110" align="center"></el-table-column>
          <el-table-column prop="click" label="点击量" width="110" align="center"></el-table-column>
          <el-table-column prop="click_p" label="点击率" width="110" align="center"></el-table-column>
          <el-table-column prop="cpc" label="cpc" width="110" align="center"></el-table-column>
          <el-table-column prop="cpm" label="cpm" width="110" align="center"></el-table-column>
          <el-table-column prop="pay" label="消耗金额(元)" width="120" align="center"></el-table-column>

        </el-table>
        <div class="page-c">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>

    <drawer-view :drawer="drawer" :adv_item="adv_item" @close_call_back="close_call_back" v-if="drawer"></drawer-view>

    <el-dialog title="修改广告组名" :close-on-click-modal="false" :visible.sync="dialogVisible2" width="30%">
      <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item label="原广告组名">
          <el-input v-model="old_title" placeholder="" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="新广告组名">
          <el-input v-model="title" placeholder=""></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="dialogVisible2 = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="sure2" size="mini">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改广告计划名" :close-on-click-modal="false" :visible.sync="dialogVisible3" width="30%">
      <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item label="原广告计划名">
          <el-input v-model="old_adv_name" placeholder="" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="新广告计划名">
          <el-input v-model="adv_name" placeholder=""></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="dialogVisible3 = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="sure3" size="mini">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改广告预算" :close-on-click-modal="false" :visible.sync="dialogVisible4" width="30%">
      <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item label="原广告预算">
          <el-input v-model="old_adv_budget" placeholder="" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="新广告预算">
          <el-input v-model="adv_budget" placeholder=""></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="dialogVisible4 = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="sure4" size="mini">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改出价" :close-on-click-modal="false" :visible.sync="dialogVisible5" width="30%">
      <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item label="原价格">
          <el-input v-model="old_price" placeholder="" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="新价格">
          <el-input v-model="price" placeholder=""></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="dialogVisible5 = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="sure5" size="mini">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  /* global require */
  name: 'index',
  data() {
    return {
      form: {
        status: '',
        type: '',
        plan_keyword: '',
        material_keyword: '',
        keyword: '',
        isData: true,
        system: '',
        pay_time: [],
        upload_type: '',
        position: '',
        pay_type: ''
      },
      drawer: false,
      adv_item: [],
      page: 1,
      pageSize: 10,
      pageTotal: 1,
      tableData: [],
      handleData: ['审核中', '审核不通过', '审核通过'],
      uploadData: ['', '大图', '单图', '三图', '开屏', '新视频', '新大图', '橱窗大图'],
      company_name: '',
      old_title: '',
      title: '',
      plan_id: '',
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      adv_name: '',
      old_adv_name: '',
      adv_id: '',
      adv_budget: '',
      old_adv_budget: '',
      price: '',
      old_price: ''
    };
  },
  mounted() {
    this.company_name = JSON.parse(sessionStorage.getItem('user_info'))['company_name'];
    this.getData();
    this.$function.hiddenLoading();
  },
  methods: {
    rowChange(row, column, cell, event) {
      this.$set(row, 'isShowEditIcon', true);
      // row['isShowEditIcon'] = true;
    },
    leaveRow(row, column, cell, event) {
      this.$set(row, 'isShowEditIcon', false);
    },
    editOne5(index) {
      const item = this.tableData[index];
      this.old_price = item.price;
      this.price = '';
      this.adv_id = item.adv_id;
      this.dialogVisible5 = true;
    },
    sure5() {
      if (this.price === '') {
        this.$message.error('请输入新价格');
        return false;
      }
      this.$http.post('/trader/plan/editAdvPrice', {
        adv_id: this.adv_id,
        price: this.price
      }).then(res => {
        if (res.code === 200) {
          this.dialogVisible5 = false;
          this.getData();
        }
      });
    },
    editOne4(index) {
      const item = this.tableData[index];
      this.old_adv_budget = item.adv_budget;
      this.adv_budget = '';
      this.adv_id = item.adv_id;
      this.dialogVisible4 = true;
    },
    sure4() {
      if (this.adv_budget === '') {
        this.$message.error('请输入新广告预算');
        return false;
      }
      this.$http.post('/trader/plan/editAdvBudget', {
        adv_id: this.adv_id,
        adv_budget: this.adv_budget
      }).then(res => {
        if (res.code === 200) {
          this.dialogVisible4 = false;
          this.getData();
        }
      });
    },
    editOne3(index) {
      const item = this.tableData[index];
      this.old_adv_name = item.adv_name;
      this.adv_name = '';
      this.adv_id = item.adv_id;
      this.dialogVisible3 = true;
    },
    sure3() {
      if (this.adv_name === '') {
        this.$message.error('请输入新广告计划名');
        return false;
      }
      this.$http.post('/trader/plan/editAdvName', {
        adv_id: this.adv_id,
        adv_name: this.adv_name
      }).then(res => {
        if (res.code === 200) {
          this.dialogVisible3 = false;
          this.getData();
        }
      });
    },
    editOne2(index) {
      const item = this.tableData[index];
      this.old_title = item.title;
      this.title = '';
      this.plan_id = item.plan_id;
      this.dialogVisible2 = true;
    },
    sure2() {
      if (this.title === '') {
        this.$message.error('请输入新广告组名');
        return false;
      }
      this.$http.post('/trader/plan/editPlanTitle', {
        plan_id: this.plan_id,
        title: this.title
      }).then(res => {
        if (res.code === 200) {
          this.dialogVisible2 = false;
          this.getData();
        }
      });
    },
    getData() {
      this.form = Object.assign({}, this.form, { page: this.page, pageSize: this.pageSize });
      this.$http.post('/trader/plan/getAdvLists', this.form).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.pageTotal = res.count;
          this.$function.hiddenLoading();
        }
      });
    },
    handleSizeChange(value) {
      this.page = 1;
      this.pageSize = value;
      this.getData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getData();
    },
    search() {
      this.tableData = [];
      this.page = 1;
      this.getData();
    },
    addPlan() {
      this.$emit('add_plan', 'adv');
    },
    editOne(item) {
      this.$emit('edit_call_back', item);
    },
    delOne(adv_id) {
      this.$http.post('/trader/plan/delAdv', { adv_id }).then(res => {
        if (res.code === 200) {
          this.getData();
        }
      });
    },
    copyOne(adv_id) {
      this.$http.post('/trader/plan/copyAdv', { adv_id }).then(res => {
        if (res.code === 200) {
          this.getData();
        }
      });
    },
    showDrawer(item) {
      this.adv_item = item;
      this.drawer = true;
    },
    close_call_back() {
      this.drawer = false;
    },
    changeStatusOne(index) {
      const val = this.tableData[index].status ? 1 : 0;
      this.$http.post('/trader/plan/changeAdvStatus', {
        adv_id: this.tableData[index].adv_id,
        value: val
      }).then(res => {
        if (res.code === 200) {
          this.getData();
          this.$message.success('操作成功，仅审核通过的创意可修改状态');
        } else {
          this.$message.error('操作失败');
        }
      });
    }
  },
  watch: {

  },
  components: {
    DrawerView: resolve => require(['@/views/Component/Drawer.vue'], resolve)
  }
};
</script>

<style lang="less" scoped>
  .top {
    height: 54px;
    background-color: #f9f9f9;
    margin-bottom: 31px;
    font-size: 16px;
    font-weight: 700;
    line-height: 54px;
    color: #333;
    padding-left: 22px;
  }
  .body {
    width: calc(100% - 69px);
    margin-left: 23px;
    width: 1640px;
    .condition {
      margin-top: 20px;
      width: 1400px;
      height: 55px;
      .form {
        float: left;
        width: 1645px;
      }
      .other {
        float: right;
        width: 440px;
      }
      .demo-input-suffix {
        display: inline-block;
        font-size: 14px;
        color: #999;
        margin-right: 31px;
      }
    }
    .page-c {
      margin-top: 20px;
      text-align: right;
      margin-right: 30px;
    }
  }

</style>
